/**
 * Returns group
 * @param {String} route
 */
export const getGroupName = route => {
    const pageGroupName = {
        'account-register': 'Account',
        checkout: 'Checkout'
    };

    return pageGroupName[route.name] || null;
};

/**
 * Returns page name
 * @param {String} route
 * @param {String} token
 */
export const getPageName = (route, token) => {
    const pageNames = {
        'account-register': 'Account Signup',
        checkout: 'Checkout 1 Overview',
        checkoutGuest: 'Checkout 1 Guest'
    };

    const isCheckoutGuest = (pageNames[route.name] === pageNames.checkout) && !token;
    const group = pageNames[route.name] || null;

    return isCheckoutGuest ? pageNames.checkoutGuest : group;
};
